import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import i18n from "i18n";
import useFilters from "hooks/useFilters";

import { TagService } from "services/TagService";

import { isMobile } from "helpers/Mobile";

import AdminLayout from "components/MainApp/layouts/DesktopLayout";
import Loader from "components/MainApp/atoms/Loader";

import MainNotification from "components/MainApp/atoms/Notification";
import SimpleSearchPanel from "components/MainApp/organisms/Filters/SimpleSearchPanel";
import TemplateTagsTable from "views/Admin/Tag/TagList/TemplateTagsTable";
import Pagination from "components/MainApp/atoms/Pagination";

import tableHeaders from "./tableHeaders";
import {
  filterData as FilterDataSource,
  filterTypeMap
} from "./data/filterData";

import styles from "./TagList.module.scss";
import { NotFoundItems } from "views/Admin/components/NotFoundItems";


import FilterPanel from "components/MainApp/organisms/Filters/FilterPanel";

const initialFilters = {
  page_size: 10,
  search: "",
  ordering: "-created_at",
  type: undefined,
  mem_epc: undefined,
  mem_user: undefined
};

let scrolling = false;

export const ConfigTagListView = () => {
  const [recOrderFilters, setRecOrderFilters] = useState();
  const history = useHistory();
  const [loading, setloading] = useState(false);
  const [noItems, setNoItems] = useState(false);
  const [filterData, setFilterData] = useState(FilterDataSource);

  const [orders_name, setOrders_name] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const myRef = useRef(0);

  const [
    filters,
    setFilters,
    selectedFiltersAll,
    selectedFiltersByType,
    handleApplyFilters,
    handleSearch,
    headerOrderingHandler,
    resetOrdering,
    handleFiltersChangeOrdering,
    applied,
    page,
    setPage,
    items,
    setItems,
    pager,
    setPager,
    header,
    setHeader,
    mobilePanelOpen,
    setMobilePanelOpen
  ] = useFilters(
    initialFilters,
    recOrderFilters,
    filterTypeMap,
    isMobile,
    tableHeaders
  );

  const headerOptions = [
    {
      icon: "icon-iconos_mas2",
      name: "add",
      handler: () => {
        history.push("/admin/config_tags/add");
      },
      tooltip: i18n.t("add.template.tag")
    }
  ];

  useEffect(() => {
    fillFilterData();
    TagService.configTags().then(response => {
      setOrders_name(response);
    });
  }, []);

  useEffect(() => {
    setMobilePanelOpen(false);
    const first_load =
      JSON.stringify(initialFilters) === JSON.stringify(filters);
    filter(first_load);
    // Acomodar orden
    const keyOrdering =
      filters.ordering.charAt(0) === "-"
        ? filters.ordering.substr(1)
        : filters.ordering;
    if (keyOrdering in tableHeaders) {
      const newHeaders = { ...header };
      newHeaders[keyOrdering]["active"] = true;
      newHeaders[keyOrdering]["direction"] =
        filters.ordering === keyOrdering ? true : false;
      setHeader(newHeaders);
    }
  }, []);

  useEffect(() => {
    if(isFirstLoad){
      setIsFirstLoad(false);
      return;
    }
    filter(false);
    setRecOrderFilters({
      filters: filters,
      selectedFiltersAll: selectedFiltersAll,
      selectedFiltersByType: selectedFiltersByType
    });
  }, [filters, page]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  });

  const handleScroll = event => {
    if (!isMobile) return;

    if (
      event.srcElement.offsetHeight + event.target.scrollTop + 100 <
      event.srcElement.scrollHeight
    )
      return;

    if (!pager.next || submitted || scrolling) return;
    scrolling = true;

    setPage(page + 1);
  };

  const handlePagerChange = function(page) {
    setPage(page);
  };

  const filter = function(firstLoad = false) {
    let append = isMobile;
    if (!append) {
      setItems([]);
    }

    //BEFORE SUBMIT
    document.body.style.cursor = "wait";
    setSubmitted(true);
    // setErrors({})
    // setMessage({})

    const data = { ...filters, page: page };
    data["type"] = data["type"] ? data["type"].join(",") : undefined;
    data["mem_epc"] = data["mem_epc"] ? data["mem_epc"].join(",") : undefined;
    data["mem_user"] = data["mem_user"] ? data["mem_user"].join(",") : undefined;

    setloading(true);
    TagService.configTagsPaginated(data)
      .then(response => {
        //this.afterSubmit();
        setSubmitted(false);
        document.body.style.cursor = "default";
        scrolling = false;

        const newOrders = append
          ? [...items, ...response.results]
          : response.results;

        setloading(false);
        setItems(newOrders);
        setPager({
          next: response.next,
          previous: response.previous,
          count: response.count,
          countPages: Math.ceil(response.count / filters.page_size)
        });
      })
      .catch(e => {
        setSubmitted(false);
        document.body.style.cursor = "default";
        scrolling = false;
      });
  };

  const fillFilterData = function() {
    let filterDataAux = [...filterData];

    if (isMobile) {
      filterDataAux[4] = {
        type: "twoOption",
        options: [
          {
            selected: false,
            label: i18n.t("less.recent"),
            value: "created_at"
          }
        ],
        label: i18n.t("order.by"),
        firstOptionLabel: i18n.t("latest"),
        value: "-created_at"
      };
    }
    setFilterData(filterDataAux);
  };


  const goToDetailPage = event => {
    const item = items.find(
      o => o.id === event.currentTarget.dataset.itemtagId
    );
    history.push(`/admin/config_tags/detail/${item?.id}`);
  };

  const goToEditPage = event => {
    history.push(`/admin/config_tags/detail/${event.currentTarget.dataset.itemtagId}`)
  };

  const mobileContent = (
    <React.Fragment>
      <div className={styles["configTag-table-filter-container"]}>
        <SimpleSearchPanel
          placeholder={i18n.t("search.by.name.or.description")}
          handleSubmit={handleSearch}
        />
      </div>

      <div
        className={`${styles["configTag-table-mobile-panel"]} ${
          mobilePanelOpen ? styles["opened"] : ""
        } `}
      >
        <FilterPanel
          resultList={orders_name}
          placeholder={i18n.t("search.by.name.or.description")}
          searchValue={filters.search}
          handleSubmitSearch={handleSearch}
          filters={filterData}
          selectedFiltersAll={selectedFiltersAll}
          selectedFiltersByType={selectedFiltersByType}
          handleApplyFilters={handleApplyFilters}
          closeMobilePanel={() => {
            setMobilePanelOpen(false);
          }}
        ></FilterPanel>
      </div>
      <div className={styles["configTag-table-table"]}>
        <div className={styles["configTag-table-top-table"]}>
          <div className={styles["configTag-table-top-total"]}>
            Total{" "}
            <span className={styles["configTag-table-top-total-bold"]}>
              ({pager.count})
            </span>
          </div>
          <div
            className={`${styles["configTag-table-top-sort"]} ${
              applied ? styles["configTag-table-active-filter"] : ""
            }`}
            onClick={() => {
              setMobilePanelOpen(true);
            }}
          >
            <i className={`icon-iconos_filtros ${styles["configTag-table-top-icon"]}`}></i>
          </div>
        </div>
        <TemplateTagsTable
          itemTags={items}
          headers={header}
          handleClickTemplateTag={goToDetailPage}
          // mapTypes={recTypeMapping}
        />
      </div>

      {items.length === 0 && !submitted && (
        <NotFoundItems />
      )}
    </React.Fragment>
  );

  // DESKTOP START
  const desktopContent = (
    <div className={styles["configTag-content-wrapper"]}>
      <FilterPanel
        resultList={orders_name}
        placeholder={i18n.t("search.by.name.or.description")}
        searchValue={filters.search}
        handleSubmitSearch={handleSearch}
        filters={filterData}
        selectedFiltersAll={selectedFiltersAll}
        selectedFiltersByType={selectedFiltersByType}
        handleApplyFilters={handleApplyFilters}
      ></FilterPanel>

      {items.length > 0 && (
        <div className={styles["configTag-table-table"]}>
          <div className={styles["configTag-table-top-table"]}>
            <div className={styles["configTag-table-top-total"]}>
              TOTAL{" "}
              <span className={styles["configTag-table-top-total-bold"]}>
                ({pager.count})
              </span>
            </div>
            <div className={styles["configTag-table-top-sort"]}>
              <div
                data-automation-id="configTag-table-sort"
                className={
                  filters.ordering.includes("created_at")
                    ? `${styles["configTag-table-top-sort"]} ${styles["configTag-table-active-filter"]}`
                    : styles["configTag-table-top-sort"]
                }
                onClick={() => {
                  handleFiltersChangeOrdering(
                    "ordering",
                    filters.ordering === "-created_at"
                      ? "created_at"
                      : "-created_at"
                  );
                  resetOrdering();
                }}
              >
                {filters.ordering === "created_at" ? (
                  <React.Fragment>
                    {i18n.t("less.recent")}{" "}
                    <i className={`icon-chevron ${styles["configTag-table-top-icon"]}`}></i>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {" "}
                    {i18n.t("latest")}{" "}
                    <i className={`icon-chevron-down ${styles["configTag-table-chevron-down"]} ${styles["configTag-table-top-icon"]}`}></i>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
          <TemplateTagsTable
            itemTags={items}
            headers={tableHeaders}
            headerClickHandler={headerOrderingHandler}
            handleClickTemplateTag={goToDetailPage}
            handleClickDraft={goToEditPage}
          />
        </div>
      )}

      {items.length === 0 && !submitted && (
        <NotFoundItems />
      )}
      {items.length > 0 && (
        <div>
          <Pagination
            pageQuantity={pager.countPages}
            currentPage={page}
            pageChangeHandler={handlePagerChange}
          />
        </div>
      )}
    </div>
  );
  // DESKTOP END

  const content = (
    <div className={styles["configTag-content-container"]}>
      {isMobile ? mobileContent : desktopContent}
    </div>
  );

  return (
    <div className={styles["configTag-container"]}>
      <AdminLayout
        headerTitle={i18n.t("template.tags")}
        headerOptions={headerOptions}
        content={content}
        navHidden={false}
        goBackFunc={() => {
          history.push("/admin/more-options-tags");
        }}
      ></AdminLayout>
      {loading && <Loader />}
      <MainNotification
        label={i18n.t("product.updated.successfully.message")}
        open={false}
      ></MainNotification>
    </div>
  );
};

export default ConfigTagListView;
